import { chatActions } from "../../chat";
import { getLastReadMessageEventData } from "../providers";
import type { AppStore } from "../../../store";
import type { LastReadMessageContent } from "../types";

const { updateMessageStatuses } = chatActions;

export const updateMessageStatusesHandler = (
  storeAPI: AppStore,
  msg: LastReadMessageContent
) => {
  if (msg) {
    const { lastReadMessageId } = getLastReadMessageEventData(msg);

    storeAPI.dispatch(updateMessageStatuses({ lastReadMessageId }));
  }
};
